import { FAQSection as BaseFAQSection } from '@roselabs-io/saas-shell'
import type { FAQ } from '@roselabs-io/saas-shell'

const faqs: FAQ[] = [
  {
    question: 'How do I integrate with my app?',
    answer:
      'Use our lightweight SDK for automatic error capture and reporting. SDKs are available for JavaScript, Python, React, and Next.js. Just add the SDK, configure your API key, and errors are captured automatically.',
  },
  {
    question: 'How does uptime monitoring work?',
    answer:
      "Set a ping URL for your app (like /health or /api/status), and we'll check it at your chosen interval (1-60 minutes). If the endpoint returns a non-2xx status or times out, we'll mark it as down and alert you. You'll also get notified when it recovers.",
  },
  {
    question: 'Can I cancel anytime?',
    answer:
      "Absolutely! There are no contracts or commitments. You can upgrade, downgrade, or cancel your subscription at any time. If you cancel, you'll keep access until the end of your current billing period. Your data remains accessible for 30 days after cancellation.",
  },
  {
    question: 'Do you store my source code?',
    answer:
      'No, we never store your source code. We only store error messages, stack traces, and metrics you explicitly send us. This metadata helps you debug issues but contains no proprietary business logic.',
  },
  {
    question: 'How are alerts delivered?',
    answer:
      'Create alert profiles to route notifications to email, Slack, or webhooks. Configure which events trigger alerts (errors, downtime, recovery, metric thresholds) and set cooldown periods to avoid alert spam.',
  },
  {
    question: 'What are custom metrics?',
    answer:
      'Custom metrics let you track any numeric value in your app—queue lengths, response times, user counts, whatever matters to you. Set thresholds to get alerted when values go too high or low. Great for monitoring business KPIs alongside technical metrics.',
  },
  {
    question: 'How do I notify my team?',
    answer:
      'Set up alert profiles to route notifications where your team already works—email, Slack channels, or custom webhooks. Create different profiles for different severity levels or apps. No account creation required for recipients.',
  },
  {
    question: 'How does error grouping work?',
    answer:
      'We automatically group similar errors together based on error type, message pattern, and stack trace. This helps you see how often an issue occurs and prioritize fixes, rather than being overwhelmed by duplicate alerts for the same bug.',
  },
]

export function FAQSection() {
  return (
    <BaseFAQSection
      faqs={faqs}
      productName="Falcon"
      gradientColor="#dc2626"
      sectionClassName="bg-slate-300"
      badge={{
        bgColor: 'bg-primary-100',
        borderColor: 'border-primary-300',
        textColor: 'text-primary-800',
      }}
      contactLink={{
        textColor: 'text-primary-600',
        hoverColor: 'hover:text-primary-700',
      }}
      bottomCta={{
        iconBgColor: 'bg-primary-100',
        iconBorderColor: 'border-primary-200',
        iconColor: 'text-primary-600',
        contactTextColor: 'text-primary-600',
        contactHoverColor: 'hover:text-primary-700',
      }}
      useAccordionGroup={true}
    />
  )
}
